import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const getFeedbacks = createAsyncThunk(
  "feedback/getFeedbacks",
  async ({ page = 1, limit = 10, search = "", status = "" } = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();
      if (page) queryParams.append("page", page);
      if (limit) queryParams.append("limit", limit);
      if (search) queryParams.append("search", search);
      if (status) queryParams.append("status", status);

      const response = await axiosHttp.get(`feedback/list?${queryParams.toString()}`);
      return response.data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

const FeedbackListSlice = createSlice({
  name: "FeedbackListSlice",
  initialState: {
    isLoading: false,
    data: [],
    pagination: null,
    error: null,
  },
  reducers: {
    resetFeedbackList: (state) => {
      state.isLoading = false;
      state.data = [];
      state.pagination = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFeedbacks.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getFeedbacks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || [];
        state.pagination = action.payload?.pagination || null;
      })
      .addCase(getFeedbacks.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetFeedbackList } = FeedbackListSlice.actions;
export default FeedbackListSlice.reducer;
